import { render } from "./PicturePicker.vue?vue&type=template&id=150981c8"
import script from "./PicturePicker.vue?vue&type=script&lang=js"
export * from "./PicturePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__